(function () {
    function swiperInit() {
        subSliderInit(true);
        sliderInit(true);
    }

    document.addEventListener('shopify:section:load', function (e) {
        swiperInit();
    });

    var lastWindowWidth = window.innerWidth;

    window.addEventListener('resize', function () {
        var currentWindowWidth = window.innerWidth;

        if (currentWindowWidth === lastWindowWidth) return;

        lastWindowWidth = currentWindowWidth;

        $('.product-section .js-media-list').each(function () {
            if (this.swiper && !this.swiper.destroyed) {
                this.swiper.destroy();
            }
        });

        $('.product-section .js-media-sublist').each(function () {
            if (this.swiper && !this.swiper.destroyed) {
                this.swiper.destroy();
            }
        });

        swiperInit();
    });

    swiperInit();
})();